export default __webpack_public_path__ + "static/media/award-green.eb8b99a0.svg";